import React from 'react';
import { Helmet } from 'react-helmet';
import VideoAdProduction from './VideoAdProduction';

const VideoAdProductionPage = () => (
  <>
    <Helmet>
      <title>Video Ad Production | MilaajBrandset</title>
      <meta
        name="description"
        content="Create impactful video advertisements that tell your brand’s story. MilaajBrandset offers comprehensive video ad production services from concept to final edit, designed to engage and convert your audience."
      />
      <meta
        name="keywords"
        content="Video Ad Production, Concept Development, Scriptwriting, Professional Editing, Targeted Distribution, MilaajBrandset"
      />
      <meta property="og:title" content="Video Ad Production | MilaajBrandset" />
      <meta
        property="og:description"
        content="Create impactful video advertisements that tell your brand’s story. MilaajBrandset offers comprehensive video ad production services from concept to final edit, designed to engage and convert your audience."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.milaajbrandset.com/video-ad-production" />
      <meta property="og:image" content="https://www.milaajbrandset.com/images/video-ad-og-image.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Video Ad Production | MilaajBrandset" />
      <meta
        name="twitter:description"
        content="Create impactful video advertisements that tell your brand’s story. MilaajBrandset offers comprehensive video ad production services from concept to final edit, designed to engage and convert your audience."
      />
      <meta name="twitter:image" content="https://www.milaajbrandset.com/images/video-ad-twitter-image.jpg" />
    </Helmet>
    <VideoAdProduction />
  </>
);


export default VideoAdProductionPage;